import React from 'react';
import { CSkeleton, Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { VersionLockSvg } from 'src/assets/dynamicSvg';
import { formatDate } from 'src/utils/misc';
import { useVersionsQuery } from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql/client';

const VersionContainer = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.cflowerBlue};
  }
`;

interface VersionHeaderProps {
  assessmentId: string;
  version: string;
}

export const VersionHeader: React.FC<VersionHeaderProps> = ({ assessmentId, version }) => {
  const {
    data: versionsData,
    networkStatus,
    loading,
  } = useVersionsQuery({ variables: { assessmentId: assessmentId! }, skip: !assessmentId });
  const isLoading = isQueryLoading({ networkStatus, data: versionsData, loading });

  const versionDate = versionsData?.assessment?.versions?.find((el) => el.id === version)?.meta?.createdAt || '';

  return (
    <VersionContainer data-cy="version-header">
      <VersionLockSvg />
      {isLoading ? (
        <CSkeleton width={150} height={20} />
      ) : (
        <>
          <Poppins px={14} color="cflowerBlue">
            {versionsData?.assessment?.versions?.find((el) => el.id === version)?.name}
          </Poppins>
          <Spacer $px={10} $horizontal />
          <Poppins px={14} color="cflowerBlue">
            |
          </Poppins>
          <Spacer $px={10} $horizontal />
          <Poppins px={14} color="cflowerBlue">
            {versionsData?.assessment?.versions?.find((el) => el.id === version)?.meta?.createdBy}
          </Poppins>
          <Spacer $px={10} $horizontal />
          <Poppins px={14} color="cflowerBlue">
            |
          </Poppins>
          <Spacer $px={10} $horizontal />
          <Poppins px={14} color="cflowerBlue">
            {formatDate(versionDate)}
          </Poppins>
        </>
      )}
    </VersionContainer>
  );
};
